// @ts-nocheck
import "../../sass/pages/home.scss";

const forward = document.getElementById("forward")
const back = document.getElementById("back")
const carrousel = document.getElementById("carrousel")
let limit = 7

/* window.addEventListener("resize", (win, evt) => {
    const width: number = win.target.innerWidth
    counter = 0;
    carrousel.style.transform = `translateX(-${(carrousel.children[0].clientWidth + 10) * counter}px)`
    switch (true) {
        case (width > 1300 - (carrousel.children[0].clientWidth + 10)):
            limit = 7
            break;
        case (width <= 1300 - (carrousel.children[0].clientWidth + 10) && width > 1300 - ((carrousel.children[0].clientWidth + 10) * 2)):
            limit = 6
            break;

        case (width <= 1300 - ((carrousel.children[0].clientWidth + 10) * 2) && width > 1300 - ((carrousel.children[0].clientWidth + 10) * 3)):
            limit = 5
            break;

        case (width <= 1300 - ((carrousel.children[0].clientWidth + 10) * 3) && width > 1300 - ((carrousel.children[0].clientWidth + 10) * 4)):
            limit = 4
            break;
        case (width <= 850):
            limit = 3
            break;
        default:
            break;
    }
}) */


window.addEventListener("load", () => {
    carrousel.style.justifyContent = carrousel.children.length < limit ? "center" : "start"
    const images = [...document.getElementsByClassName("eternos__slide")] as HTMLElement[]
    images.forEach(item => item.addEventListener("click", () => {
        const activeImages = images.filter(item => item.classList.contains("active"))
        activeImages.forEach(item => item.classList.remove("active"))
        item.classList.toggle("active")
    }))
    forward.addEventListener("click", forwardAction)
    back.addEventListener("click", backAction)

    sendHomeDataLayer()
    sendDatalayer()
});



const forwardAction: (obj: HTMLElement, evt: MouseEvent) => any = (obj, evt) => {
    carrousel.scrollLeft += carrousel.children[0].clientWidth + 10
}
const backAction: (obj: HTMLElement, evt: MouseEvent) => any = (obj, evt) => {
    carrousel.scrollLeft -= carrousel.children[0].clientWidth + 10
}

const sendHomeDataLayer = () => {
    //dataLayer IR REGISTRO seccion 1
    const btnSec1 = document.getElementById("btn_sec_1");
    if (btnSec1) {
        btnSec1.addEventListener("click", () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content',
                'event_action': 'button',
                'event_label': 'Registrate y Vive la experiencia',
                'interaction': 'true',
                'component_name': 'button_Registrate',
                'element_text': 'Registrate y vive la experiencia',
                'campaign_description': 'Eternos'
            });
        })
    }

    //dataLayer CONOCE DON ABEL
    const btnDonAbel = document.getElementById("btn_don_abel");
    if (btnDonAbel) {
        btnDonAbel.addEventListener("click", () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content',
                'event_action': 'button',
                'event_label': 'Conoce a don Abel',
                'interaction': 'true',
                'component_name': 'button_conoceadonabel',
                'element_text': 'Conoce a don Abel',
                'campaign_description': 'Eternos'
            });
        })
    }

    //datalayer sumate al legado
    const btnSumateLegado = document.getElementById("sumate_al_legado");
    if (btnSumateLegado) {
        btnSumateLegado.addEventListener("click", () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content',
                'event_action': 'button',
                'event_label': 'Sumate al legado',
                'interaction': 'true',
                'component_name': 'button_legadoeterno',
                'element_text': 'Sumate al legado',
                'campaign_description': 'Eternos'
            });
        })
    }

    //datalayer explora nuestra siembra
    const btnExploraSiembra = document.getElementById("explora_siembra");
    if (btnExploraSiembra) {
        btnExploraSiembra.addEventListener("click", () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content',
                'event_action': 'button',
                'event_label': 'Explora nuestra siembra',
                'interaction': 'true',
                'component_name': 'button_legadoeterno',
                'element_text': 'Explora nuestra siembra',
                'campaign_description': 'Eternos'
            });
        })
    }
}
const sendDatalayer = () => {

    const btn = document.querySelector('.eternos__bannerCans__right a')
    btn.addEventListener("click", () => {

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'GAEvent',
            event_category: 'Content',
            event_action: 'button',
            event_label: 'Comprar ahora en Tada',
            interaction: 'true',
            component_name: 'button_comprarahora',
            element_text: 'Comprar ahora en Tada',
            campaign_description: 'Eternos'
        })
    })
}
